import https from './api'
function request(method, url, { data, params, ...config } = {}) {
    // console.log(headers);

    return https({
        method: method.toLowerCase(),
        url,
        data,
        params,
        ...config
    })
}
const methods = ['get', 'post', 'put', 'delete', 'patch', 'head', 'options']
methods.forEach(method => {
    request[method] = (url, { data, params, ...config } = {}) => {
        return request(method, url, { data, params, ...config })
    }
})

export default request
